import { setError } from 'src/fetch/common';
import _ from 'lodash';

/**
 * User Result 세팅
 */
export const dataSet = (data: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  // const errorSet = { type: '' };
  const deepData = _.cloneDeep(data);
  const dataSet = deepData;

  const resultSet = {
    resError: errorSet,
    resData: deepData.data?.result,
  };
  return resultSet;
};

/**
 * User Result 세팅
 */
export const familyDataSet = (data: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const deepData = _.cloneDeep(data);
  const dataSet = deepData;
  const resultSet = {
    resError: errorSet,
    resData: deepData.data?.result,
  };
  return resultSet;
};
